import { render, staticRenderFns } from "./FormReasons.vue?vue&type=template&id=c8e9135c&scoped=true&"
import script from "./FormReasons.vue?vue&type=script&lang=js&"
export * from "./FormReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e9135c",
  null
  
)

export default component.exports